import { createSlice } from '@reduxjs/toolkit';
import getAdapter from '../getAdapter';

const rentalCompaniesAdapter = getAdapter();

const rentalCompaniesSlice = createSlice({
  name: 'rentalCompanies',
  initialState: rentalCompaniesAdapter.getInitialState(),
  reducers: {
    setRentalCompanies: (state, { payload: { rentalCompanies } }) => {
      rentalCompaniesAdapter.setAll(state, rentalCompanies);
    },
  },
});

const selectors = rentalCompaniesAdapter.getSelectors(({ rentalCompanies }) => rentalCompanies);

export const getRentalCompanies = (state) => selectors.selectAll(state);

export const { setRentalCompanies } = rentalCompaniesSlice.actions;

export default rentalCompaniesSlice.reducer;
